import request from './request'

export function getTransactions(params) {
  return request({
    url: '/admin/finance/transactions',
    method: 'get',
    params
  })
}

// 按 runner_id 精确查询跑手独立钱包流水（role_code=runner，对应跑手钱包分表）
export function getRunnerTransactions(params) {
  return request({
    url: '/admin/finance/runner-transactions',
    method: 'get',
    params
  })
}

export function getWithdraws(params) {
  return request({
    url: '/admin/finance/withdraws',
    method: 'get',
    params
  })
}

export function approveWithdraw(id, remark) {
  return request({
    url: `/admin/finance/withdraws/${id}/approve`,
    method: 'post',
    data: remark ? { remark } : {}
  })
}

export function payWithdraw(id) {
  return request({
    url: `/admin/finance/withdraws/${id}/pay`,
    method: 'post'
  })
}

export function rejectWithdraw(id, remark) {
  return request({
    url: `/admin/finance/withdraws/${id}/reject`,
    method: 'post',
    data: remark ? { remark } : {}
  })
}

export function failWithdraw(id, remark) {
  return request({
    url: `/admin/finance/withdraws/${id}/fail`,
    method: 'post',
    data: remark ? { remark } : {}
  })
}

export function getBills(params) {
  return request({
    url: '/admin/finance/bills',
    method: 'get',
    params
  })
}

export function getTransfers(params) {
  return request({
    url: '/admin/finance/transfers',
    method: 'get',
    params
  })
}